import { create } from 'zustand';

interface NavigationActivityState {
  counts: Readonly<Record<string, number>>;
}

export const useNavigationActivityStore = create<NavigationActivityState>(() => ({
  counts: {},
}));

/** Feature-owned background work publishes only a count. The shared navigation stays independent
 * of every feature's task model and lifecycle vocabulary. */
export const navigationActivityActions = {
  setCount: (id: string, count: number): void => {
    const normalized = Math.max(0, Math.floor(count));
    useNavigationActivityStore.setState((state) => {
      if ((state.counts[id] ?? 0) === normalized) return state;
      const counts = { ...state.counts };
      if (normalized === 0) delete counts[id];
      else counts[id] = normalized;
      return { counts };
    });
  },
  clear: (id: string): void => {
    useNavigationActivityStore.setState((state) => {
      if (state.counts[id] === undefined) return state;
      const counts = { ...state.counts };
      delete counts[id];
      return { counts };
    });
  },
};
